{
  "dashboards": {
    "list": {
      "navigation_title": "Dashboard List",
      "title": "Dashboard List"
    },
    "navigation_title": "Dashboards",
    "title": "Dashboards",
    "add_dashboard": "New Dashboard",
    "new_dashboard": "New Dashboard",
    "open_dashboard": "Open Dashboard",
    "add_widgets": "Add Widgets",
    "widget_groups": {
      "data": "Data & Trends",
      "location": "Location"
    },
    "widget_descriptions": {
      "chart_widget": "Overlaid time-series lines",
      "heatmap_widget": "Status-colored latest value grid",
      "node_widget": "Status card with latest values",
      "map_widget": "Geospatial view of device locations",
      "wind_rose_widget": "Wind direction and speed distribution",
      "connectivity_widget": "Online/offline timeline per device",
      "distribution_widget": "Distribution of a parameter's readings per device"
    },
    "not_found": "No dashboards match the current filters",
    "visibility": {
      "shared": "Shared",
      "shared_hint": "Everyone in the organization sees this dashboard; its managers edit it"
    },
    "share": {
      "title": "Share Dashboard",
      "hint": "Everyone in the organization will see this dashboard. Only its managers will be able to edit it."
    },
    "starred": "Starred",
    "unshare": {
      "action": "Unshare",
      "title": "Make this dashboard private?",
      "text": "It becomes your private dashboard. Others in the organization won't see it anymore.",
      "confirm": "Make private",
      "done": "The dashboard is private to you now"
    },
    "dialogs": {
      "delete": {
        "title": "Are you sure?",
        "content": "Are you sure you want to delete '%{name}' dashboard? You can't undo this action"
      }
    }
  }
}
